import { State } from 'app/redux';

export const getSettingsPurchaseOrder = (state: State) =>
  state.settings.purchaseOrder;
